

export class Tutor{    
  idPersonaPeriodo:number;
  idUsuario:number;
  nombres:string;
  apellidos:string;
  correo:string;
  constructor(){
      this.idPersonaPeriodo = 0;
      this.idUsuario = 0;
      this.nombres = "";
      this.apellidos = "";
      this.correo = "";
  }
}

export class ResponseTutor{
  payload:Tutor;

    constructor(){
        this.payload = new Tutor();
    }
}


export class AgendarTutoria{    
  idJardinPeriodoTutoria:number;
  idTutorDisponibilidad:number;
 
  constructor(){
      this.idJardinPeriodoTutoria = 0;
      this.idTutorDisponibilidad = 0;
  }
}



